import type { CrudAdapter } from '@botto/core';
import { useCrudDataSource } from '@botto/core';
import { smsClient } from '../client';
import type { Domain, DomainCreate, DomainUpdate } from '../types';

export const domainsAdapter: CrudAdapter<Domain, DomainCreate, DomainUpdate> = {
  async list({ offset, limit, sortName, sortDirection }) {
    const query = {
      offset,
      limit,
      'sort.name': sortName ?? 'id',
      'sort.direction': (sortDirection ?? 'asc') as 'asc' | 'desc',
    };
    const { data, error } = await smsClient.GET('/domains/', { params: { query } });
    if (error) throw error;
    return { items: data?.items ?? [], total: data?.total ?? 0 };
  },
  async create(payload) {
    const { data, error } = await smsClient.POST('/domains/', { body: payload });
    if (error) throw error;
    return { id: data?.id ?? 0 };
  },
  async update(payload) {
    const { data, error } = await smsClient.PUT('/domains/', { body: payload });
    if (error) throw error;
    return (data ?? payload) as Domain;
  },
  async byKey(id) {
    const { data, error } = await smsClient.GET('/domains/{item_id}', {
      params: { path: { item_id: Number(id) } },
    });
    if (error) throw error;
    return data as Domain;
  },
  async remove(id) {
    const { error } = await smsClient.DELETE('/domains/{item_id}', {
      params: { path: { item_id: Number(id) } },
    });
    if (error) throw error;
  },
};

export const domainsStore = useCrudDataSource(domainsAdapter);
